import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import useProductService from '../../../app/services/hooks/useProductService';
import { ProductDataForm, defaultProductDataForm } from '../../../app/models/Product';
import { Unit } from '../../../app/models/Unit';
import { ItemCategory } from '../../../app/models/ItemCategory';
import { Location } from '../../../app/models/Location';
import { Sector } from '../../../app/models/Sector';
import { Quality } from '../../../app/models/Quality';
import { Color } from '../../../app/models/Color';
import ProductForm from './forms/ProductForm';

type SelectOpt = { id: number | string; name: string };

interface Props { onSaved?: () => void; onCancel?: () => void; onError?: () => void; }

const NOOP = () => undefined;

const ProductCreate = ({ onSaved, onCancel = NOOP, onError }: Props) => {
  const { showLoading, hideLoading } = useContext(AppContext);
  const { fetchingStoreProduct, storeProduct, createProduct } = useProductService();

  const [product, setProduct] = useState<ProductDataForm>(defaultProductDataForm);
  const [units, setUnits] = useState<Unit[]>([]);
  const [ownershipTypes, setOwnershipTypes] = useState<SelectOpt[]>([]);
  const [taxes, setTaxes] = useState<SelectOpt[]>([]);
  const [sectors, setSectors] = useState<Sector[]>([]);
  const [categories, setCategories] = useState<ItemCategory[]>([]);
  const [locations, setLocations] = useState<Location[]>([]);
  const [qualities, setQualities] = useState<Quality[]>([]);
  const [colors, setColors] = useState<Color[]>([]);
  const [errorFields, setErrorFields] = useState<any>();

  useEffect(() => {
    showLoading?.('loading', 'Cargando datos...');
    createProduct({
      onSuccess: (res: ServiceResponse) => {
        setUnits(res.data.units || []);
        setOwnershipTypes(res.data.ownership_types || []);
        setTaxes(res.data.taxes || []);
        setSectors(res.data.sectors || []);
        setCategories(res.data.categories || []);
        setLocations(res.data.locations || []);
        setQualities(res.data.qualities || []);
        setColors(res.data.colors || []);
        hideLoading?.();
      },
      onError: (res: ServiceResponse) => {
        hideLoading?.();
        toast.error(res.message);
        onError && onError();
      }
    });
  }, []);

  const store = () => {
    showLoading?.('loading', 'Guardando producto...');
    storeProduct(product, {
      onSuccess: (res: ServiceResponse) => {
        hideLoading?.();
        useReactConfirmAlert().successAlert({ title: 'Éxito', message: res.message });
        toast.success(res.message, { autoClose: 2500 });
        onSaved && onSaved();
      },
      onError: (res: ServiceResponse) => {
        hideLoading?.();
        useReactConfirmAlert().errorAlert({ title: 'Error', message: res.message });
      },
      onFieldError: (errs: ServiceResponse) => {
        hideLoading?.();
        setErrorFields(errs.data);
      }
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <ProductForm
            productDataForm={product}
            setProductDataForm={setProduct}
            units={units}
            ownershipTypes={ownershipTypes}
            taxes={taxes}
            sectors={sectors}
            categories={categories}
            locations={locations}
            qualities={qualities}
            colors={colors}
            errorFields={errorFields}
          />
        </div>
      </div>
      <hr />
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={onCancel} locked={!!fetchingStoreProduct} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm callbackSave={store} locked={!!fetchingStoreProduct} />
        </div>
      </div>
    </>
  );
};

export default ProductCreate;
